// src/pages/SettingsPage.jsx
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem clamp(1rem, 5vw, 3rem);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.25rem;

  @media (min-width: 768px) {
    gap: 1.5rem;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }

  @media (min-width: 1440px) {
    gap: 2rem;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
`;

const SettingCard = styled.div`
  background: var(--white-a15);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid var(--white-a25);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 24px var(--shadow-a08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const SettingLabel = styled.span`
  font-weight: 600;
  font-size: clamp(0.9rem, 1vw + 0.4rem, 1.1rem);
  color: var(--green-800);
  font-family: var(--font-body);
  text-shadow: 0 1px 1px var(--shadow-a05);
`;

const ToggleTrack = styled.button`
  position: relative;
  width: 52px;
  height: 28px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: background 0.25s ease, box-shadow 0.25s ease;
  background: ${({ $on }) => ($on ? 'var(--green-800)' : 'var(--shadow-a15)')};
  box-shadow: ${({ $on }) =>
    $on
      ? '0 0 8px 2px var(--green-a30)'
      : '0 2px 6px var(--shadow-a15)'};

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px var(--orange-a60);
  }
`;

const ToggleThumb = styled.span`
  position: absolute;
  top: 3px;
  left: ${({ $on }) => ($on ? '26px' : '3px')};
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${({ $on }) => ($on ? 'var(--orange-500)' : 'var(--white)')};
  box-shadow: 0 1px 4px var(--shadow-a15);
  transition: left 0.25s ease, background 0.25s ease;
  pointer-events: none;
`;

const SettingValue = styled.span`
  font-size: clamp(0.85rem, 1vw + 0.35rem, 1rem);
  color: var(--green-800);
  font-family: var(--font-body);
  opacity: 0.7;
`;

const SettingsPage = () => {
  const [dmEnabled, setDmEnabled] = useState(false);

  useEffect(() => {
    document.title = 'The Vault – Settings';
  }, []);

  return (
    <main>
      <Container>
        <SettingCard>
          <SettingLabel>Version</SettingLabel>
          <SettingValue>{process.env.REACT_APP_VERSION || '—'}</SettingValue>
        </SettingCard>

        <SettingCard>
          <SettingLabel>DM</SettingLabel>
          <ToggleTrack
            $on={dmEnabled}
            onClick={() => setDmEnabled(prev => !prev)}
            role="switch"
            aria-checked={dmEnabled}
            aria-label="DM toggle"
          >
            <ToggleThumb $on={dmEnabled} />
          </ToggleTrack>
        </SettingCard>
      </Container>
    </main>
  );
};

export default SettingsPage;
